import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ContentSection from '../ContentSection';
import Navbar from '../Navbar';
import HoursAndLocation from './HoursAndLocation';
import './styles.css';

export default class StoreInfoPage extends Component {

  constructor(props) {
    super(props);
    this._sections = [
      {
        name: 'Hours & Location',
        href: '/hours'
      }
    ];
  }

  render() {
    return (
      <Navbar location={this.props.location}>
        <div className="store-info-page">
          <ContentSection>
            <h1>A locally-owned, independent music store serving Greater Lafayette's musicians since 1971</h1>
            <ul>
              <li>
                Lafayette's largest store specializing in guitars, basses, amps, folk instruments, drums, and professional audio
              </li>
              <li>
                Lafayette's largest teaching studio offering professional, <Link to="/lessons">private instruction on guitar, bass, drums, banjo, mandolin, and ukelele</Link>
              </li>
              <li>
                We also offer <Link to="/repair">repair and adjustment</Link> of guitars and other stringed instruments.
              </li>
              <li>
                Proud member of the National Association of Music Merchants.
              </li>
            </ul>
            <div className="section-links">
              {this._sections.map(this._renderSectionLink)}
            </div>
          </ContentSection>
          <ContentSection className="store-info-section" containerClassName="theme-background">
            {this._renderSection()}
          </ContentSection>
        </div>
      </Navbar>
    );
  }

  _renderSection = () => {

    switch(this.props.location.pathname) {
      case '/hours':
        return <HoursAndLocation/>;
      default:
        return null;
    }
  }

  _renderSectionLink = (section) => {

    const className = section.href === this.props.location.pathname ? 'link-section-active' : '';
    return <Link key={section.name} className={className} to={section.href}>{section.name}</Link>;
  }
}



// WEBPACK FOOTER //
// ./src/components/StoreInfoPage/index.js